import { lazy } from "react";
import Loadable from "app/components/Loadable";

const Prepare1098 = Loadable(lazy(() => import("./Prepare1098")));

const prepare1098Route = [{ path: "/prepare-1098", element: <Prepare1098 /> }];
export default prepare1098Route;
